import * as React from 'react';

import { EPosition, FiltersSection } from '../../components/FiltersSection';

export const FiltersSectionContainer = ({ children }: React.PropsWithChildren) => {
  const [filtersSectionPosition, setFiltersSectionPosition] = React.useState<EPosition>(EPosition.default);
  const updateFiltersHeightCb = React.useRef<() => void | undefined>(undefined);

  const setUpdateHeightCb = React.useCallback((cb: () => void) => {
    updateFiltersHeightCb.current = cb;
  }, []);

  return (
    <FiltersSection
      position={filtersSectionPosition}
      setUpdateHeightCb={setUpdateHeightCb}
      onChangePosition={setFiltersSectionPosition}
    >
      {children}
    </FiltersSection>
  );
};
